// @flow
import React from 'react'
import useSpecification from '../hooks/useSpecification'
import { serverUrl } from '../Services/SuriApi'

type UseSpecificationType = {
  fetchResource: Function,
  onInit: Function,
  productName: string,
  token: string,
}

const WithUseSpecification = (props: UseSpecificationType) => {
  const { productName, token, fetchResource, onInit, children } = props

  const validatorObject = useSpecification({
    validatorSrc: `${serverUrl}/product/${productName}/validator.js?access_token=${token}`,
    fetchResource,
    onInit,
  })

  return children(validatorObject)
}

export default WithUseSpecification
